import { RoutesApp } from "./routes/index";
import { BrowserRouter } from "react-router-dom";
import GlobalStyles from "./styles/global";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-calendar/dist/Calendar.css";
import "react-multi-carousel/lib/styles.css";
import "devextreme/dist/css/dx.light.css";
import AppProvider from "./context";
import { ConfigProvider } from "antd";
import ptBR from "antd/es/locale/pt_BR";
import { CookieBanner } from "./components/CookieBanner";
import { GoogleAnalytics } from "./components/GoogleAnalytics";

function App() {
  return (
    <BrowserRouter basename="/">
      <GoogleAnalytics />
      <AppProvider>
        <GoogleOAuthProvider clientId="731161939030-k15eddt5mp9fn90jefeae5ckah2vgalc.apps.googleusercontent.com">
          <ToastContainer style={{ zIndex: "200000000000" }} />
          <GlobalStyles />
          <ConfigProvider
            locale={ptBR}
            theme={{
              components: {
                Carousel: {
                  arrowSize: 200,
                },
              },
            }}
          ></ConfigProvider>
          <RoutesApp />
          <CookieBanner />
        </GoogleOAuthProvider>
      </AppProvider>
    </BrowserRouter>
  );
}

export default App;
